import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

import backofficeApiClient from 'api/backofficeApiClient';

interface BullhornState {
  isConnectBullhornAccountModalOpen: boolean;
}

const initialState: BullhornState = {
  isConnectBullhornAccountModalOpen: false,
};

interface GetPlacementsDetailsModel {
  pageSize: number;
  pageNumber: number;
}
const getPlacementsDetails = createAsyncThunk(
  'bullhorn/getPlacementsDetails',
  async (data: GetPlacementsDetailsModel) => {
    return backofficeApiClient.getPlacements(data.pageSize, data.pageNumber);
  },
);

const bullhornSlice = createSlice({
  name: 'bullhorn',
  initialState,
  reducers: {
    handleBullhornConnectModalOpen: (
      state,
      action: PayloadAction<boolean>,
    ) => ({
      ...state,
      isConnectBullhornAccountModalOpen: action.payload,
    }),
  },
  extraReducers: (builder) => {},
});

const { reducer, actions } = bullhornSlice;
const { handleBullhornConnectModalOpen } = actions;

export { getPlacementsDetails, handleBullhornConnectModalOpen };

export default reducer;
